import React, { useState } from "react";
import { Link } from "react-router-dom"; 
 
import svg1 from "./img/svg1.svg"; 
import svg2 from "./img/svg2.svg"; 
import svg3 from "./img/svg3.svg"; 
import svg4 from "./img/svg4.svg"; 

import w1 from "./img/w1.jpg";
import w2 from "./img/w2.jpg";
import t1 from "./img/t1.png";
import t2 from "./img/t2.png";
import t3 from "./img/t3.png";
import w3 from "./img/w3.jpg";
import i4 from "./img/i4.jpg";
import i3 from "./img/i3.jpg";
import i5 from "./img/i5.jpg";
import i6 from "./img/i6.jpg";
import i7 from "./img/i7.jpg";
import i8 from "./img/i8.jpg";  

import { Menu, ChevronDown, Headphones, PhoneCall } from "react-feather";

const TopPlaces = () => {
   

  return (
    <>





 

<div className="container mb-5 mt-5">

  <div className="text-start">
    <h1>Top Places</h1>
  </div>
<div className="row g-3">
  <div className="col-md-4 ">
    <div className=" border bg-white packagediv">
      <div><img src={w1} alt="" className="img-fluid img4"/></div>
      <div className="p-3 text-start">
        <div className="txt1">Yamunotri</div>
        <div className="text-blue">Source of River Yamuna 3293 metres</div>
      </div>
    </div>
  </div>

  <div className="col-md-4 ">
    <div className=" border bg-white packagediv">
      <div><img src={w2} alt="" className="img-fluid img4"/></div>
      <div className="p-3 text-start">
        <div className="txt1">Yamunotri</div>
        <div className="text-blue">Source of River Yamuna 3293 metres</div>
      </div>
    </div>
  </div>

  <div className="col-md-4 ">
    <div className=" border bg-white packagediv">
      <div><img src={w3} alt="" className="img-fluid img4"/></div>
      <div className="p-3 text-start">
        <div className="txt1">Yamunotri</div>
        <div className="text-blue">Source of River Yamuna 3293 metres</div>
      </div>
    </div>
  </div>


  <div className="col-md-4 ">
    <div className=" border bg-white packagediv">
      <div><img src={w3} alt="" className="img-fluid img4"/></div>
      <div className="p-3 text-start">
        <div className="txt1">Yamunotri</div>
        <div className="text-blue">Source of River Yamuna 3293 metres</div>
      </div>
    </div>
  </div>


  <div className="col-md-4 ">
    <div className=" border bg-white packagediv">
      <div><img src={w3} alt="" className="img-fluid img4"/></div>
      <div className="p-3 text-start">
        <div className="txt1">Yamunotri</div>
        <div className="text-blue">Source of River Yamuna 3293 metres</div>
      </div>
    </div>
  </div>


  <div className="col-md-4 ">
    <div className=" border bg-white packagediv">
      <div><img src={w3} alt="" className="img-fluid img4"/></div>
      <div className="p-3 text-start">
        <div className="txt1">Yamunotri</div>
        <div className="text-blue">Source of River Yamuna 3293 metres</div>
      </div>
    </div>
  </div>
</div>
</div>

 
 
    </>
  );
};

export default TopPlaces;
